import { motion } from "framer-motion";
import { Crosshair, Activity, FileSearch, Wallet } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";

const FEATURES = [
  {
    icon: Crosshair,
    title: "Daily Picks",
    desc: "Carefully selected NBA betting opportunities, posted with odds, units and reasoning — never just a logo and a line.",
    testid: "feature-daily-picks",
  },
  {
    icon: Activity,
    title: "Player Props",
    desc: "Player markets supported by matchup data, usage trends and minutes projections — where the softest lines live.",
    testid: "feature-player-props",
  },
  {
    icon: FileSearch,
    title: "Pick Analysis",
    desc: "Members understand why a selection was made instead of blindly tailing. Every pick ships with the work shown.",
    testid: "feature-pick-analysis",
  },
  {
    icon: Wallet,
    title: "Bankroll Management",
    desc: "Unit sizing and educational content built around disciplined wagering — the difference between surviving and compounding.",
    testid: "feature-bankroll",
  },
];

export function Features() {
  return (
    <section className="border-y border-[#1E2738] bg-[#0A0D14]" data-testid="features-section">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-24 lg:px-8">
        <SectionHeader
          eyebrow="The Product"
          title="What Money Printer Provides"
          sub="A real research process packaged for members — not a list of logos with arrows."
          testid="features-header"
        />
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              data-testid={f.testid}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: i * 0.07 }}
              className="card-mp card-hover p-6"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-lg border border-[#00E676]/30 bg-[#00E676]/10">
                <f.icon size={20} className="text-[#00E676]" />
              </div>
              <h3 className="mt-5 font-display text-xl font-bold uppercase tracking-wide text-white">{f.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
